import React, { useState, useCallback, memo, useMemo, useEffect } from "react";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Button from "@mui/material/Button";
import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import TimePicker from "../TimePicker";
import DatePickerComponent from "../DatePicker";
import IconPlus from "../../assents/img/plus.svg";
import IconArrow from "../../assents/img/arrow.svg";
import IconMinus from "../../assents/img/minus.svg";
import IconCheckbox from "../../assents/img/checkbox.svg";
import ChangeTourRouteModal from "../Modals/ChangeTourRouteModal";

const Wrapper = styled(Box)(({ theme }) => ({
  marginLeft: "auto",
  marginRight: "auto",
  width: "335px",
  [theme.breakpoints.up("sm")]: {
    width: "100%",
  },
}));

const Form = styled(Box)(({ theme }) => ({
  width: "335px",
  margin: "-90px auto 0 auto",
  backgroundColor: "white",
  borderRadius: "10px",
  boxSizing: "border-box",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
  [theme.breakpoints.up("sm")]: {
    width: "440px",
    margin: "-196px auto 0 auto",
  },
}));

const FormHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  height: "90px",
  padding: "20px",
  backgroundColor: "#ededed",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  boxSizing: "border-box",
  [theme.breakpoints.up("sm")]: {
    height: "71px",
    padding: "23px 18px",
  },
}));

const HeaderText = styled(Typography)(() => ({
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "18px",
  lineHeight: 1.22,
  color: "#1a1a1a",
}));

const HeaderButton = styled(Button)(({ theme }) => ({
  height: "37px",
  width: "77px",
  marginBottom: "auto",
  padding: "10px 14px",
  background: "rgba(26, 26, 26, 0.9)",
  borderRadius: "5px",
  color: "#ffffff",
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "14px",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": {
    background: "rgba(26, 26, 26, 0.9)",
  },
  [theme.breakpoints.up("sm")]: {
    width: "auto",
    margin: 0,
  },
}));

const FormBody = styled(Box)(({ theme }) => ({
  padding: "15px 20px 23px",
  [theme.breakpoints.up("sm")]: {
    padding: "16px 18px 27px",
  },
}));

const FormLabel = styled(Typography)(() => ({
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "18px",
  lineLeight: "1.35",
  marginBottom: "7px",
}));

const TimeWrapp = styled(Box)(({ theme, warning }) => ({
  border: `1px solid ${warning ? 'red' : 'white'}`,
  display: "inline-block",
  position: "relative",
  width: "140px",
  marginLeft: "11px",
  [theme.breakpoints.up("sm")]: {
    width: "136px",
  },
}));

const TimeInput = styled("input")(({ theme }) => ({
  padding: "12px 10px",
  width: "100%",
  height: "44px",
  border: "1px solid #d9d9d9",
  borderRadius: "4px",
  boxSizing: "border-box",
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.187,
  color: "#1a1a1a",
  cursor:'pointer',
  "&:focus": { borderColor: "#2bb656", borderWidth: "2px", outline: "none" },
  "&::placeholder": {
    fontFamily: "Proxima Nova",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: 1.187,
    color: "#1a1a1a",
  },
  [theme.breakpoints.up("sm")]: {
    padding: "14px 12px",
    fontSize: "14px",
    "&::placeholder": {
      fontSize: "14px",
      lineHeight: "1.214",
    },
  },
}));

const ArrowWrap = styled(Box)(() => ({
  height: "32px",
  width: "32px",
  position: "absolute",
  bottom: "6px",
  right: "1px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "&:hover": {
    borderRadius: "50%",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
}));

const HotelWrapp = styled(Box)(({ theme }) => ({
  marginTop: "30px",
  [theme.breakpoints.up("sm")]: {
    marginTop: "32px",
  },
}));

const HotelInput = styled("input")(({ theme, warning }) => ({
  padding: "14px 10px",
  width: "100%",
  height: "44px",
  border: `1px solid ${warning ? 'red' : '#d9d9d9'}`,
  borderRadius: "4px",
  boxSizing: "border-box",
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.187,
  color: "#1a1a1a",
  "&:focus": { borderColor: "#2bb656", borderWidth: "2px", outline: "none" },
  "&::placeholder": {
    fontFamily: "Proxima Nova",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: 1.187,
    color: "#1a1a1a",
  },
  [theme.breakpoints.up("sm")]: {
    padding: "14px 12px",
    fontSize: "14px",
    "&::placeholder": {
      fontSize: "14px",
      lineHeight: "1.214",
    },
  },
}));

const CheckboxWrapp = styled(Box)(({ theme }) => ({
  marginTop: "11px",
  display: "flex",
  [theme.breakpoints.up("sm")]: {
    marginTop: "15px",
    alignItems: "center",
  },
}));

const Checkbox = styled("input")(({ theme }) => ({
  width: "20px",
  height: "20px",
  margin: 0,
  cursor: "pointer",
  [theme.breakpoints.up("sm")]: {
    padding: "14px 12px",
    "&::placeholder": {
      fontSize: "14px",
      lineHeight: "1.214",
    },
  },
}));

const CheckedCheckbox = styled(Box)(() => ({
  display: "inline-block",
  width: "20px",
  height: "20px",
  background: "#2bb656",
  borderRadius: "4px",
  backgroundImage: `url(${IconCheckbox})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "8px 9px",
  cursor: "pointer",
}));

const ChackboxLabel = styled("label")(({ theme }) => ({
  marginLeft: "9px",
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.187,
  color: "#1a1a1a",
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
    lineHeight: 1.214,
  },
}));

const PeopleWrap = styled(Box)(({ theme }) => ({
  marginTop: "37px",
  [theme.breakpoints.up("sm")]: {
    marginTop: "39px",
  },
}));

const PeopleListItem = styled(ListItem)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: 0,
  boxSizing: "border-box",
  "&:not(:last-child)": { marginBottom: "15px" },
}));

const PeopleItemText = styled(Typography)(({ theme }) => ({
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  fontSize: "16px",
  lineHeight: 1.25,
  color: "#1a1a1a",
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
    lineHeight: 1.42,
  },
}));

const PeopleItemSubText = styled(Typography)(({ theme }) => ({
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.3,
  color: "#1a1a1a",
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
  },
}));

const Hr = styled("hr")(() => ({
  opacity: "0.1",
}));

const TotalWrap = styled(Box)(() => ({
  width: "83px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const TotalIcon = styled("img")(() => ({
  cursor: "pointer",
}));

const TotalValue = styled(Typography)(({ theme }) => ({
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.3,
  color: "#1a1a1a",
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
  },
}));

const IconButtonCustom = styled(IconButton)(() => ({
  padding: 0,
}));


const InputAutoComplite = styled("ul")(({ismobile}) => ({
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
  borderRadius:'10px',
  listStyle: "none",
  padding:'unset',
  margin:'unset',
  cursor:'pointer',
  fontFamily: "Proxima Nova",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: 1.187,
  '& li:hover': {
    backgroundColor:"#ededed",
  },
  '& li': {
    fontSize: ismobile ? '16px' : '14px',
lineHeight: '20px',
paddingTop:'5px',
paddingBottom:'5px',
paddingLeft:'13px',
marginBottom:'0px',
  }
}));

const LocationWarning = styled("div")(() => ({
  marginTop:"5px",
  fontSize:'14px',
  color:'red' 
}));

const DropOffWarning = styled("div")(() => ({
  marginTop:"5px",
  fontSize:'14px',
  color:'red' 
}));

const DateAndTimeWarning = styled("div")(() => ({
  display:'flex',
  fontSize:'14px', 
  justifyContent:"space-between",
  marginTop:'5px',
  color:'red',
}));

const FormSection = memo(
  ({
    setDateNotEmpty,
    setTimeNotEmpty,
    dateNotEmpty,
    timeNotEmpty,
    dropOffNotEmpty,
    setDropOffNotEmpty,
    setLocationNotEmpty,
    locationNotEmpty,
    isMobile,
    dropOffAutocomplete,
    pickupAutocomplete,
    tourDataInfo,
    allRoutes,
    total,
    setTotal,
    date,
    setDate,
    time,
    setTime,
    checkboxIsCheked,
    setCheckboxIsCheked,
    pickUpLocation,
    setPickUpLocation,
    dropOffLocation,
    setDropOffLocation,
  }) => {
    const [timePickerIsOpen, setTimePickerIsOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [inputOpen, setInputOpen] = useState(false)
    const [dropInputOpen, setDropInputOpen] = useState(false)


  const placePickHandler = useCallback((place) => {
      setPickUpLocation(place)
      setInputOpen(false)
    }, [])

    const dropPickHandler = useCallback((place) => {
      setDropOffLocation(place)
      setDropInputOpen(false)
    }, [])

    const pickupAutoPlaces = useMemo(() => {
      if (pickUpLocation.trim().length > 0 && pickUpLocation.trim().length < 15) {
        return pickupAutocomplete.map(place => <li onClick={() => {placePickHandler(place); setLocationNotEmpty(false)}} key={place}>{place}</li>)
      } else {
        return <div></div>
      }
    }, [pickupAutocomplete])


    const dropAutoPlace = useMemo(() => {
      if (dropOffLocation.trim().length > 0 && dropOffLocation.trim().length < 15) {
        return dropOffAutocomplete.map(place => <li onClick={() => {dropPickHandler(place); setDropOffNotEmpty(false)}} key={place}>{place}</li>)
      } else {
        return <div></div>
      }
    }, [dropOffAutocomplete])
    

  
   
    const handleChange = useCallback(
      () => setCheckboxIsCheked((prev) => {
        setDropOffLocation('')
        return !prev}),
      [setCheckboxIsCheked]
    );

    const handlePlus = useCallback(
      (e) => {
        const type = e.target.name;
        setTotal((prev) => ({ ...prev, [type]: prev[type] + 1 }));
      },
      [setTotal]
    );

    const handleMinus = useCallback(
      (e) => {
        const type = e.target.name;
        setTotal((prev) =>
          prev[type] === 0 ? prev : { ...prev, [type]: prev[type] - 1 }
        );
      },
      [setTotal]
    );

    const handleOpenTimepicker = useCallback(() => {
      setTimePickerIsOpen((prev) => !prev);
    }, []);

    const handleOpen = useCallback(() => setOpenModal(true), []);

    const handleClose = useCallback(() => setOpenModal(false), []);

    const handleDropOffLocationChange = useCallback(
      (e) => {
        setDropOffLocation(e.target.value);
      },
      [setDropOffLocation]
    );

    useEffect(() => {
        if (pickUpLocation.trim().length === 0) {
          setPickUpLocation('')
        }
    },[pickUpLocation])

    useEffect(() => {
      if (!checkboxIsCheked) {
        if (dropOffLocation.trim().length === 0) {
        setDropOffLocation('')
      }
      }
  },[dropOffLocation])

    const handleLocationChange = useCallback(
      (e) => {
        setPickUpLocation(e.target.value);
      },
      [setPickUpLocation]
    );
    return (
      <>
        <Wrapper>
          <Form>
            <FormHeader>
              <HeaderText>{tourDataInfo.name}</HeaderText>
              <HeaderButton onClick={handleOpen}>Change</HeaderButton>
            </FormHeader>
            <FormBody>
              <Box>
                <FormLabel>Departure date & time</FormLabel>
                <DatePickerComponent
                  isMobile={isMobile}
                  warning={dateNotEmpty ? 'true' : ''}
                  setDateNotEmpty={setDateNotEmpty}
                  date={date}
                  setDate={setDate}
                  setTime={setTime}
                />
                <TimeWrapp onClick={handleOpenTimepicker} warning={timeNotEmpty ? 'true' : ''}>
                  <TimeInput
                    value={time}
                    placeholder="Choose time"
                    type="text"
                    readOnly
                  />
                  <ArrowWrap>
                    <img src={IconArrow} alt="Arrow icon" />
                  </ArrowWrap>
                  {timePickerIsOpen && (
                    <TimePicker
                      setTime={setTime}
                      date={date}
                      setTimeNotEmpty={setTimeNotEmpty}
                      setTimePickerIsOpen={setTimePickerIsOpen}
                    />
                  )}
                  
                </TimeWrapp>
                {(dateNotEmpty || timeNotEmpty) && <DateAndTimeWarning>
                  <div style={{opacity: dateNotEmpty ? '1' : '0'}}>This field is required</div>
                  <div style={{opacity: timeNotEmpty ? '1' : '0', marginRight:'10px'}}>This field is required</div>
                  </DateAndTimeWarning>}
              </Box>
              <HotelWrapp>
                <FormLabel>Pickup location</FormLabel>
                <HotelInput
                  warning={locationNotEmpty}
                  onClick={() => setInputOpen(true)}
                  placeholder="Your hotel, Airbnb etc."
                  value={pickUpLocation}
                  onChange={handleLocationChange}
                />
                {locationNotEmpty && <LocationWarning>This field is required</LocationWarning>} 
                {inputOpen && <InputAutoComplite ismobile={isMobile}>{pickUpLocation.length ? pickupAutoPlaces : null}</InputAutoComplite>}
                {!checkboxIsCheked && <>
                  <FormLabel style={{marginTop:'5px'}}>Drop-off location</FormLabel>
                  <HotelInput
                  style={{border: `1px solid ${dropOffNotEmpty ? 'red' : '#d9d9d9'}`}}
                  onClick={() => setDropInputOpen(true)}
                  placeholder="Your hotel, Airbnb etc."
                  value={dropOffLocation}
                  onChange={handleDropOffLocationChange}
                />
                {dropOffNotEmpty && <DropOffWarning>This field is required</DropOffWarning> } 
                {dropInputOpen && <InputAutoComplite ismobile={isMobile}>{dropOffLocation.length ? dropAutoPlace : null}</InputAutoComplite>}
                </>}
                <CheckboxWrapp>
                  {checkboxIsCheked ? (
                    <CheckedCheckbox onClick={handleChange} />
                  ) : (
                    <Checkbox
                      type="checkbox"
                      name="hotel"
                      onClick={handleChange}
                    />
                  )}
                  
                  <ChackboxLabel htmlFor="hotel">
                    Drop-off location is the same as pickup
                  </ChackboxLabel>
                </CheckboxWrapp>
              </HotelWrapp>
              <PeopleWrap>
                <FormLabel>People</FormLabel>
                <Hr />
                <List sx={{ padding: 0 }}>
                  <PeopleListItem>
                    <PeopleItemText>Adults</PeopleItemText>
                    <TotalWrap>
                      <IconButtonCustom onClick={handleMinus}>
                        <TotalIcon src={IconMinus} name="adults" />
                      </IconButtonCustom>
                      <TotalValue>{total.adults}</TotalValue>
                      <IconButtonCustom onClick={handlePlus}>
                        <TotalIcon src={IconPlus} name="adults" />
                      </IconButtonCustom>
                    </TotalWrap>
                  </PeopleListItem>
                  <PeopleListItem>
                    <Box>
                      <PeopleItemText>Children</PeopleItemText>
                      <PeopleItemSubText>Ages 5-18</PeopleItemSubText>
                    </Box>
                    <TotalWrap>
                      <IconButtonCustom onClick={handleMinus}>
                        <TotalIcon src={IconMinus} name="children" />
                      </IconButtonCustom>
                      <TotalValue>{total.children}</TotalValue>
                      <IconButtonCustom onClick={handlePlus}>
                        <TotalIcon src={IconPlus} name="children" />
                      </IconButtonCustom>
                    </TotalWrap>
                  </PeopleListItem>
                  <PeopleListItem>
                    <Box>
                      <PeopleItemText>Infants</PeopleItemText>
                      <PeopleItemSubText>Under 5</PeopleItemSubText>
                    </Box>
                    <TotalWrap>
                      <IconButtonCustom onClick={handleMinus}>
                        <TotalIcon src={IconMinus} name="infants" />
                      </IconButtonCustom>
                      <TotalValue>{total.infants}</TotalValue>
                      <IconButtonCustom onClick={handlePlus}>
                        <TotalIcon src={IconPlus} name="infants" />
                      </IconButtonCustom>
                    </TotalWrap>
                  </PeopleListItem>
                </List>
              </PeopleWrap>
            </FormBody>
          </Form>
        </Wrapper>
        <ChangeTourRouteModal
          allRoutes={allRoutes}
          currentTourId={tourDataInfo.id}
          open={openModal}
          handleClose={handleClose}
        />
      </>
    );
  }
);

export default FormSection;
